const permissionGroups = { family: "items", subfamily: "items", category: "categories", subcategory: "categories", item: "items", supplier: "suppliers" };

export function canCreateCatalog(user, type) {
  const group = permissionGroups[type];
  return Boolean(group) && (Number(user?.id) === 1 || user?.permissions?.[`purchasing.${group}.create`] === true);
}

export function canEditCatalog(user, type) {
  const group = permissionGroups[type];
  return canCreateCatalog(user, type) && (Number(user?.id) === 1 || user?.permissions?.[`purchasing.${group}.update`] === true);
}
